<button class="notificationsDropDownButton"
  aria-label="show notifications"
  (click)="showNotifications()"
  >
  @if (hasUnread) {
    <i class="material-icons notificationsIcon">error</i>
  }
  <img src="/assets/img/header/notifications.svg" alt="Notifications" class="userMenu_icon">
  <span class="userMenu_item">Notifications @if (hasUnread) {
    <span>({{notificationsCount}})</span>
  }</span>
  @if (!expanded) {
    <span class="material-icons notificationsExpander">expand_more</span>
  }
  @if (expanded) {
    <span class="material-icons notificationsExpander">expand_less</span>
  }
</button>
@if (expanded) {
  <ng-scrollbar style="max-height: 500px;" [autoHeightDisabled]="false">
    <ul class="notificationsList" role="menu">
      @for (notification of notifications; track notification) {
        <li>
          @if (notification.routerLink) {
            <a
              [routerLink]="notification.routerLink"
              [queryParams]="notification.queryParams"
              tabindex=0
              (click)="closeMenuEvent()"
              >
              <div class="notification_date">{{notification.notificationDate | date:'fullDate'}}</div>
              <div class="notification_content">{{notification.description}}</div>
              <div class="notification_readMore">View</div>
            </a>
          }
          @if (!notification.routerLink) {
            <div>
              <div class="notification_date">{{notification.notificationDate | date:'fullDate'}}</div>
              <div class="notification_content">{{notification.description}}</div>
            </div>
          }
        </li>
      }
      @if (notifications.length == 0) {
        <li>
          You have no new notifications
        </li>
      }
    </ul>
  </ng-scrollbar>
}
